module.exports = __webpack_public_path__ + "static/media/no-data-found.28c3ca0f.svg";